/* Imports */
import { API_HELPER } from "@/helpers/api.js";
import { authHeader } from "@/helpers/auth-header.js";

/* Exports */
// API services that can be invoked on the modules
export const STATS_SERVICE = {
    get
};

/* Consts*/
// Root service to build API url
const API_ROOT_SERVICE = "Informations";

/* Services */
function get(languageCode)
{
    // Build API call.
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE]);    
    const requestOptions = {
        method: 'GET' ,
        headers: { ...authHeader(), "Accept-Language":languageCode}
    };


    // Process API call, validating the token beforehand.
    return API_HELPER.loggedApiCall(url, null, requestOptions);    
}